import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import Compare from "@/pages/Compare";
import Embed from "@/pages/Embed";
import Pricing from "@/pages/Pricing";
import Advisor from "@/pages/Advisor";
import Featured from "@/pages/Featured";
import Admin from "@/pages/Admin";
import AdminSocial from "@/pages/AdminSocial";
import Sponsor from "@/pages/Sponsor";
import LearnIndex from "@/pages/learn/LearnIndex";
import LearnCompound from "@/pages/learn/LearnCompound";
import LearnEmergencyFund from "@/pages/learn/LearnEmergencyFund";
import LearnFirstRoth from "@/pages/learn/LearnFirstRoth";
import LearnFourPercent from "@/pages/learn/LearnFourPercent";
import LearnSequenceRisk from "@/pages/learn/LearnSequenceRisk";
import LearnReadinessChecklist from "@/pages/learn/LearnReadinessChecklist";
import LearnReadinessWorkbook from "@/pages/learn/LearnReadinessWorkbook";
import Books from "@/pages/Books";
import EbookCentennial from "@/pages/EbookCentennial";
import AuthorsSubmit from "@/pages/AuthorsSubmit";
import MedicationSafety from "@/pages/MedicationSafety";
import WorkbookView from "@/pages/WorkbookView";
import MedCardView from "@/pages/MedCardView";
import About from "@/pages/trust/About";
import Methodology from "@/pages/trust/Methodology";
import Contact from "@/pages/trust/Contact";
import Privacy from "@/pages/trust/Privacy";
import Terms from "@/pages/trust/Terms";
import Disclaimer from "@/pages/trust/Disclaimer";
import ArticleRetire500k from "@/pages/learn/ArticleRetire500k";
import ArticleSSClaimingAge from "@/pages/learn/ArticleSSClaimingAge";
import ArticleHealthcareCosts from "@/pages/learn/ArticleHealthcareCosts";
import ArticleRetireAt65 from "@/pages/learn/ArticleRetireAt65";
import ArticleMedListParents from "@/pages/learn/ArticleMedListParents";
import ArticleStudy90to100 from "@/pages/learn/ArticleStudy90to100";
import ArticleMillionLast from "@/pages/learn/ArticleMillionLast";
import ArticleRetireAt62 from "@/pages/learn/ArticleRetireAt62";
import ArticleSpending1pct from "@/pages/learn/ArticleSpending1pct";
import { Toaster } from "sonner";
import { captureReferralScore } from "@/lib/referral";

// Capture ?score=X from the very first landing URL before React renders.
captureReferralScore();

class ErrorBoundary extends React.Component {
  state = { hasError: false };
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-[#F9F8F6] flex items-center justify-center px-6">
          <div className="text-center max-w-md">
            <h1 className="text-2xl font-medium text-[#1C2B23] mb-2">Something went wrong.</h1>
            <p className="text-sm text-[#5C6B62] mb-6">
              This page hit an unexpected error. Your saved plans are safe in your browser.
            </p>
            <a href="/" className="inline-block bg-[#2B5339] text-white rounded-full px-5 py-2.5 text-sm">
              Back to the calculator
            </a>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  return (
    <div className="App min-h-screen">
      <BrowserRouter>
        <ErrorBoundary>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/compare" element={<Compare />} />
          <Route path="/embed" element={<Embed />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/advisor" element={<Advisor />} />
          <Route path="/featured" element={<Featured />} />
          <Route path="/sponsor" element={<Sponsor />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/social" element={<AdminSocial />} />
          <Route path="/learn" element={<LearnIndex />} />
          <Route path="/learn/compound" element={<LearnCompound />} />
          <Route path="/learn/emergency-fund" element={<LearnEmergencyFund />} />
          <Route path="/learn/first-roth" element={<LearnFirstRoth />} />
          <Route path="/learn/four-percent" element={<LearnFourPercent />} />
          <Route path="/learn/sequence-risk" element={<LearnSequenceRisk />} />
          <Route path="/learn/readiness-checklist" element={<LearnReadinessChecklist />} />
          <Route path="/learn/readiness-workbook" element={<LearnReadinessWorkbook />} />
          <Route path="/learn/retire-with-500k" element={<ArticleRetire500k />} />
          <Route path="/learn/social-security-claiming-age" element={<ArticleSSClaimingAge />} />
          <Route path="/learn/retirement-healthcare-costs" element={<ArticleHealthcareCosts />} />
          <Route path="/learn/how-much-to-retire-at-65" element={<ArticleRetireAt65 />} />
          <Route path="/learn/medication-list-aging-parents" element={<ArticleMedListParents />} />
          <Route path="/learn/planning-to-100-study" element={<ArticleStudy90to100 />} />
          <Route path="/learn/how-long-will-a-million-last" element={<ArticleMillionLast />} />
          <Route path="/learn/retire-at-62-checklist" element={<ArticleRetireAt62 />} />
          <Route path="/learn/one-percent-more-spending-study" element={<ArticleSpending1pct />} />
          <Route path="/about" element={<About />} />
          <Route path="/methodology" element={<Methodology />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/books" element={<Books />} />
          <Route path="/ebook/100-year-retirement-plan" element={<EbookCentennial />} />
          <Route path="/authors/submit" element={<AuthorsSubmit />} />
          <Route path="/medication-safety" element={<MedicationSafety />} />
          <Route path="/workbook-view/:shareId" element={<WorkbookView />} />
          <Route path="/med-card/:cardId" element={<MedCardView />} />
        </Routes>
        </ErrorBoundary>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors closeButton />
    </div>
  );
}

export default App;
